import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.printing = false
    this.handleAfterPrint = this.afterPrint.bind(this)
    this.printFromLocation()
  }

  disconnect() {
    this.cleanup()
  }

  printUrl(event) {
    event.preventDefault()
    this.openPrintDialog(event.currentTarget.dataset.documentPrintUrl)
  }

  openPrintDialog(url) {
    if (this.printing) return

    this.printing = true
    this.frame = document.createElement("iframe")
    this.frame.className = "fixed bottom-0 right-0 h-px w-px border-0 opacity-0 pointer-events-none"
    this.frame.setAttribute("aria-hidden", "true")
    this.frame.addEventListener("load", () => this.printFrame(), { once: true })
    this.frame.src = url
    document.body.append(this.frame)
  }

  printFrame() {
    try {
      const printableWindow = this.frame.contentWindow
      printableWindow.addEventListener("afterprint", this.handleAfterPrint, { once: true })
      printableWindow.focus()
      printableWindow.print()
      if (this.printing) this.cleanupTimeout = window.setTimeout(() => this.cleanup(), 300000)
    } catch (error) {
      console.error("Unable to open the browser print dialog", error)
      this.cleanup()
    }
  }

  afterPrint() {
    this.cleanup()
  }

  printFromLocation() {
    const currentUrl = new URL(window.location.href)
    const templateId = currentUrl.searchParams.get("print_document_template_id")
    if (!templateId) return

    currentUrl.searchParams.delete("print_document_template_id")
    window.history.replaceState(window.history.state, "", currentUrl.toString())

    const printUrl = new URL(`${currentUrl.pathname.replace(/\/$/, "")}/generated_document/print`, currentUrl.origin)
    printUrl.searchParams.set("document_template_id", templateId)
    this.openPrintDialog(printUrl)
  }

  cleanup() {
    window.clearTimeout(this.cleanupTimeout)
    this.cleanupTimeout = null
    this.frame?.remove()
    this.frame = null
    this.printing = false
  }
}
